export const CommonEventsConfig = {
  error: "event20",
  pageChange: "event7",
  viewDisplayed: "event8",
  formInteraction: "event9",
  minorInteraction: "event9",
  linkClick: "event9",
  tooltipClick: "event9",
  cova_link_click_interaction: "event9,event61",
  cova_tooltip_click_interaction: "event9,event61",
  dropdownClick: "event9",
  customDropdownClick: "event9",
  serverError: "event9,event20"
}

export const FormSubmissionConfigs = {
  sign_off: "event5,event9",
  dispute_submit_verification: "event9,event48",
  cancel_autopay_form: "event9,event52",
  enroll_verify_form: "event9,event52",
  edit_verify_form: "event9,event52",
  cancel_autopay_form_paperless: "event9,event40,event52",
  enroll_verify_form_paperless: "event9,event40,event52",
  edit_verify_form_paperless: "event9,event40,event52",
  PopupPaperlessConfirm: "event9",
  make_a_payment_index: "event9,event17",
  confirm_payment_source_deletion: "event9,event16",
  manage_payment_source_edit_payment_source: "event9,event16",
  add_edit_payment_source_verification: "event9,event15",
  add_edit_payment_source_verification_paperless: "event9,event15,event40",
  card_activation: "event9,event33",
  online_bill_pay: "event9,event37",
  profile_form: "event9,event22,event57",
  profile_form_paperless: "event9,event22,event40,event57",
  preferences_index: "event9,event3",
  linking_form: "event9,event38",
  proactive_linking_form: "event9,event38"
}

export const PageLoadConfig = {
  aoreg_profile_form: "event7,event2",
  card_activation: "event7,event32",
}

export const ViewDisplayedConfig = {
  make_a_payment_confirmation: "event8,event18",
  online_bill_pay_index: "event8,event36",
}
